import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { PageHeader, PageHeaderToolbar } from '@toolpad/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface HomeworkPageToolbarComponentProps {
    onOpen: () => void;
}
export function HomeworkPageToolbarComponent(props: HomeworkPageToolbarComponentProps) {
    const { t } = useTranslation();

    return (
        <PageHeaderToolbar>
            <Button onClick={props.onOpen} variant='contained' color='primary' startIcon={<AddIcon />}>
                {t('homework.publish.title')}
            </Button>
        </PageHeaderToolbar>
    );
}
interface HomeworkPageToolbarProps {
    onCreateHomework: () => void;
}
export function HomeworkPageToolbar(props: HomeworkPageToolbarProps) {
    const homeworkToolBar = React.useCallback(() => <HomeworkPageToolbarComponent onOpen={props.onCreateHomework} />, [props.onCreateHomework]);

    return <PageHeader slots={{ toolbar: homeworkToolBar }} breadcrumbs={[]} />;
}
